var map = {
	"./7z.svg": "3a69",
	"./aac.svg": "6a28",
	"./ai.svg": "c8fe",
	"./archive.svg": "1fa4",
	"./arj.svg": "a57a",
	"./audio.svg": "a659",
	"./avi.svg": "df13",
	"./css.svg": "ee7c",
	"./csv.svg": "f663",
	"./dbf.svg": "62e0",
	"./doc.svg": "8871",
	"./dwg.svg": "d600",
	"./exe.svg": "7253",
	"./fla.svg": "65b5",
	"./flac.svg": "5b76",
	"./gif.svg": "a74e",
	"./html.svg": "a6b7",
	"./iso.svg": "763d",
	"./jpg.svg": "7fd1",
	"./js.svg": "988d",
	"./json.svg": "9b1b",
	"./mdf.svg": "ccaa",
	"./mp2.svg": "0cd2",
	"./mp3.svg": "d05b",
	"./mp4.svg": "64cf",
	"./mxf.svg": "0287",
	"./nrg.svg": "fb4c",
	"./pdf.svg": "f51f",
	"./png.svg": "8529",
	"./ppt.svg": "14f1",
	"./psd.svg": "9e17",
	"./rar.svg": "71d5",
	"./rtf.svg": "7bbc",
	"./svg.svg": "5155",
	"./text.svg": "9635",
	"./tiff.svg": "61c5",
	"./txt.svg": "d837",
	"./unknown.svg": "3553",
	"./video.svg": "4b35",
	"./wav.svg": "f69c",
	"./wma.svg": "0a3d",
	"./xls.svg": "87b1",
	"./xml.svg": "faa0",
	"./zip.svg": "875a"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "cc1a";